var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: "快速设定",
        okText: "确认",
        cancelText: "取消",
        width: "700px",
        visible: _vm.visible,
        "confirm-loading": _vm.confirmLoading,
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-form-model",
        {
          ref: "ruleForm",
          attrs: {
            model: _vm.formState,
            "label-col": { span: 8 },
            "wrapper-col": { span: 16 },
          },
        },
        [
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "判定值",
                        prop: "judgeValue",
                      },
                    },
                    [
                      _c("a-input-number", {
                        model: {
                          value: _vm.formState.judgeValue,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "judgeValue", $$v)
                          },
                          expression: "formState.judgeValue",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "单位",
                        prop: "judgeUnit",
                      },
                    },
                    [
                      _c(
                        "a-select",
                        {
                          model: {
                            value: _vm.formState.judgeUnit,
                            callback: function ($$v) {
                              _vm.$set(_vm.formState, "judgeUnit", $$v)
                            },
                            expression: "formState.judgeUnit",
                          },
                        },
                        [
                          _c("a-select-option", { attrs: { value: "mg/kg" } }, [
                            _vm._v("mg/kg"),
                          ]),
                          _c("a-select-option", { attrs: { value: "g/kg" } }, [
                            _vm._v("g/kg"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "判定值来源",
                        prop: "valueFrom",
                      },
                    },
                    [
                      _c(
                        "a-select",
                        {
                          model: {
                            value: _vm.formState.valueFrom,
                            callback: function ($$v) {
                              _vm.$set(_vm.formState, "valueFrom", $$v)
                            },
                            expression: "formState.valueFrom",
                          },
                        },
                        [
                          _c("a-select-option", { attrs: { value: "参考" } }, [
                            _vm._v("参考"),
                          ]),
                          _c(
                            "a-select-option",
                            { attrs: { value: "自定义" } },
                            [_vm._v("自定义")]
                          ),
                          _c("a-select-option", { attrs: { value: "引用" } }, [
                            _vm._v("引用"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "使用规定",
                        prop: "useFor",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "inline-block",
                            width: "150px",
                          },
                        },
                        [
                          _c("a-ext-local-dic-select", {
                            attrs: { "dic-key": "JudgeUseFor" },
                            model: {
                              value: _vm.formState.useFor,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "useFor", $$v)
                              },
                              expression: "formState.useFor",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }